import { useContext, useState } from "react";
import "../../styles/components-styles/sidebar-styles/LargeScreenDashboardSidebar.css";
import {
  FaHome,
  FaBook,
  FaClock,
  FaEdit,
  FaCheckCircle,
  FaChartLine,
  FaComments,
  FaChalkboardTeacher,
  FaListAlt,
  FaChevronDown,
  FaBookOpen,
  FaBrain,
  FaChevronUp,
  FaStar,
  FaQuestionCircle,
} from "react-icons/fa";
import { SidebarContext } from "../../contexts/SidebarContext";
import { useNavigate } from "react-router-dom";

function LargeScreenDashboardSidebar() {
  const navigate = useNavigate();
  const {
    showLargeScreenSidebar,
    toggleHighYieldSidebar,
    toggleExtendedTextbookSidebar,
  } = useContext(SidebarContext);
  const [isPerformanceOpen, setIsPerformanceOpen] = useState(false);
  const [isKnowledgeTutorPerformanceOpen, setIsKnowledgeTutorPerformanceOpen] =
    useState(false);

  const togglePerformanceDropdown = () => {
    setIsPerformanceOpen(!isPerformanceOpen);
  };

  const toggleKnowledgeTutorPerformanceDropdown = () => {
    setIsKnowledgeTutorPerformanceOpen(!isKnowledgeTutorPerformanceOpen);
  };

  return (
    <div
      className={`main-dashboard-sidebar-container ${
        showLargeScreenSidebar ? "open" : "close"
      }`}
    >
      {/* Header with Logo and Qbank360 text */}
      <div className="main-dashboard-sidebar-header">
        <img
          src="qbank_logo.png"
          alt="Logo"
          className="main-dashboard-sidebar-logo"
        />
        <span className="main-dashboard-sidebar-title">Qbank360</span>
      </div>

      {/* Sub-header */}
      <div className="main-dashboard-sidebar-subheader">
        <span>MRCGP Applied Knowledge Test</span>
      </div>

      {/* Navigation/Sidebar Lists */}
      <nav className="main-dashboard-sidebar-nav">
        {/* Section 1: Home */}
        <ul className="main-dashboard-sidebar-section">
          <li
            className="main-dashboard-sidebar-item"
            onClick={() => {
              navigate("/dashboard/home");
            }}
          >
            <FaHome className="main-dashboard-sidebar-icon" />
            <span>Home</span>
          </li>
        </ul>

        {/* Section 2: QUESTION CONCEPTS */}
        <div className="main-dashboard-sidebar-section-title">
          <FaQuestionCircle className="main-dashboard-sidebar-icon" />
          <span>QUESTION CONCEPTS</span>
        </div>
        <ul className="main-dashboard-sidebar-section">
          <li
            className="main-dashboard-sidebar-item"
            onClick={() => {
              navigate("/dashboard/question-questionbank");
            }}
          >
            <FaBook className="main-dashboard-sidebar-icon" />
            <span>Question bank</span>
          </li>
          {/* <li className="main-dashboard-sidebar-item" 
                        onClick={() => {
                            navigate("/dashboard/question-fixed");
                        }}
                    >
                        <FaClock className="main-dashboard-sidebar-icon" />
                        <span>Fixed set & Timed test</span>
                    </li> */}
          <li
            className="main-dashboard-sidebar-item"
            onClick={() => {
              navigate("/dashboard/question-mockexam");
            }}
          >
            <FaEdit className="main-dashboard-sidebar-icon" />
            <span>Mock exams</span>
          </li>
          <li
            className="main-dashboard-sidebar-item"
            onClick={() => {
              navigate("/dashboard/question-review");
            }}
          >
            <FaCheckCircle className="main-dashboard-sidebar-icon" />
            <span>Review questions</span>
          </li>
          <li
            className={`main-dashboard-sidebar-item dropdown ${
              isPerformanceOpen ? "open" : ""
            }`}
          >
            <div
              className="main-dashboard-sidebar-dropdown-header"
              onClick={togglePerformanceDropdown}
            >
              <FaChartLine className="main-dashboard-sidebar-icon" />
              <span>Performance</span>
              {isPerformanceOpen ? (
                <FaChevronUp className="main-dashboard-sidebar-dropdown-icon" />
              ) : (
                <FaChevronDown className="main-dashboard-sidebar-dropdown-icon" />
              )}
            </div>
            <ul className="main-dashboard-sidebar-dropdown-menu">
              <li
                className="main-dashboard-sidebar-dropdown-item"
                onClick={() => {
                  navigate("/dashboard/question-summary");
                }}
              >
                <span>Summary</span>
              </li>
              {/* <li  
                                className="main-dashboard-sidebar-dropdown-item"
                                onClick={() => {
                                    navigate("/dashboard/question-category")
                                }}
                            >
                                <span>By category</span>
                            </li> */}
              {/* <li 
                                className="main-dashboard-sidebar-dropdown-item"
                                onClick={() => {
                                    navigate("/dashboard/question-heatmap")
                                }}
                            >
                                <span>Heat map</span>
                            </li> */}
              <li
                className="main-dashboard-sidebar-dropdown-item"
                onClick={() => {
                  navigate("/dashboard/question-overview");
                }}
              >
                <span>Overtime</span>
              </li>
              {/* <li className="main-dashboard-sidebar-dropdown-item"
                                onClick={() => {
                                    navigate("/dashboard/question-analysis");
                                }}
                            >
                                <span>Analysis</span>
                            </li> */}
            </ul>
          </li>
          {/* <li className="main-dashboard-sidebar-item"
                        onClick={() => {
                            navigate("/dashboard/question-thread");
                        }}
                    
                    >
                        <FaComments className="main-dashboard-sidebar-icon" />
                        <span>Comment threads</span>
                    </li> */}
        </ul>

        {/* Section 3: KNOWLEDGE TUTOR */}
        <div className="main-dashboard-sidebar-section-title">
          <span>KNOWLEDGE TUTOR</span>
        </div>
        <ul className="main-dashboard-sidebar-section">
          <li
            className="main-dashboard-sidebar-item"
            onClick={() => {
              navigate("/dashboard/knowledge");
            }}
          >
            <FaChalkboardTeacher className="main-dashboard-sidebar-icon" />
            <span>Knowledge tutor</span>
          </li>
          {/* <li  
                        className="main-dashboard-sidebar-item"
                        onClick={() => {
                            navigate("/dashboard/knowledge-review");
                        }}
                    >
                        <FaListAlt className="main-dashboard-sidebar-icon" />
                        <span>Review facts</span>
                    </li> */}
          {/* <li
                        className={`main-dashboard-sidebar-item dropdown ${
                            isKnowledgeTutorPerformanceOpen ? 'open' : ''
                        }`}
                    >
                        <div
                            className="main-dashboard-sidebar-dropdown-header"
                            onClick={toggleKnowledgeTutorPerformanceDropdown}
                        >
                            <FaChartLine className="main-dashboard-sidebar-icon" />
                            <span>Performance</span>
                            {isKnowledgeTutorPerformanceOpen ? (
                                <FaChevronUp className="main-dashboard-sidebar-dropdown-icon" />
                            ) : (
                                <FaChevronDown className="main-dashboard-sidebar-dropdown-icon" />
                            )}
                        </div>
                        <ul
                            className="main-dashboard-sidebar-dropdown-menu"
                        >
                            <li 
                                className="main-dashboard-sidebar-dropdown-item"
                                onClick={() => {
                                    navigate("/dashboard/knowledge-summary");
                                }}
                            >
                                <span>Summary</span>
                            </li>
                            <li 
                                className="main-dashboard-sidebar-dropdown-item"
                                onClick={() => {
                                    navigate("/dashboard/knowledge-category")
                                }}
                            >
                                <span>By category</span>
                            </li>
                        </ul>
                    </li> */}
        </ul>

        {/* Section 4: CUSTOM REVISION */}
        {/* <div className="main-dashboard-sidebar-section-title">
                    <span>CUSTOM REVISION</span>
                </div>
                <ul className="main-dashboard-sidebar-section">
                    <li className="main-dashboard-sidebar-item">
                        <FaEdit className="main-dashboard-sidebar-icon" />
                        <span>Revision sets</span>
                    </li>
                </ul> */}

        {/* Section 5: TEXTBOOK */}
        <div className="main-dashboard-sidebar-section-title">
          <span>TEXTBOOK</span>
        </div>
        <ul className="main-dashboard-sidebar-section">
          <li
            className="main-dashboard-sidebar-item"
            // onClick={() => {
            //     toggleHighYieldSidebar()
            // }}
            onClick={() => {
              navigate("/dashboard/textbook");
            }}
          >
            <FaBookOpen className="main-dashboard-sidebar-icon" />
            <span>High-yield text book</span>
          </li>
          {/* <li className="main-dashboard-sidebar-item"
                        onClick={() => {
                            toggleExtendedTextbookSidebar()
                        }}
                    >
                        <FaBook className="main-dashboard-sidebar-icon" />
                        <span>Extended textbook</span>
                    </li> */}
        </ul>

        {/* Section 6: CONCEPTS */}
        {/* <div className="main-dashboard-sidebar-section-title">
                    <span>CONCEPTS</span>
                </div>
                <ul className="main-dashboard-sidebar-section">
                    <li className="main-dashboard-sidebar-item">
                        <FaBrain className="main-dashboard-sidebar-icon" />
                        <span>All concepts</span>
                    </li>
                    <li className="main-dashboard-sidebar-item">
                        <FaStar className="main-dashboard-sidebar-icon" />
                        <span>Top 100 concept</span>
                    </li>
                </ul> */}
      </nav>
    </div>
  );
}

export default LargeScreenDashboardSidebar;
